export default __webpack_public_path__ + "/dist/images/Simona.f09b3e9f77cf526c4319babccd6473a7.png";